import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {media} from "assets/css/media";
import {GroupPredictions} from "./GroupPredictions";
import {
	DrawConfirmationModal,
	LiteSquadSelect,
	PreRegistration,
} from "apps/DRAW_PREDICTOR/components";
import {checkSavedPredictions, savePredictionsInStorage} from "apps/DRAW_PREDICTOR/modules/actions";
import {Groups} from "apps/DRAW_PREDICTOR/modules/enums";
import {map} from "lodash";
import {
	checkIsChangePredictor,
	checkIsFullPredictions,
} from "apps/DRAW_PREDICTOR/modules/selectors";
import {PureButton} from "components";
import {Tour} from "apps/DRAW_PREDICTOR/components/Tour";
import officialPartner from "apps/DRAW_PREDICTOR/assets/images/logos/official_partner.svg";
import qatarWhite from "apps/DRAW_PREDICTOR/assets/images/logos/qatar_white.svg";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH} from "modules";
import {handleModalState} from "apps/DRAW_PREDICTOR/modules/actions/modals";
import {EditPredictionLIteModal} from "apps/DRAW_PREDICTOR/components/Modals/EditPredictionLIteModal";

const PredictionsWrap = styled.div`
	margin: 0 auto;
	width: 100%;
`;
const PredictionWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 0 16px;
	margin: 0 auto;

	@media (min-width: ${media.mobile}) {
		justify-content: space-between;
	}
	@media (min-width: ${media.mobile}) {
		&:hover {
			.plus-icon {
				background: #ff004c;
			}
		}
	}
`;

const LogoWrapper = styled.div`
	display: none;
	align-items: center;
	justify-content: center;
	gap: 10px;
	margin-top: 14px;

	@media (max-width: ${media.mobile}) {
		display: flex;
	}
`;

const PredictorContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	max-width: 1440px;
	margin: 0 auto 100px;
	width: 100%;

	@media (max-width: ${media.mobile}) {
		margin: 0 auto 260px;
	}
`;

const MoreButton = styled(PureButton)`
	display: none;
	position: absolute;
	top: 0;
	right: 32px;
	color: #fff;
	font-size: 14px;

	@media (max-width: ${media.mobile}) {
		display: inline;
	}
`;
const Inner = styled.div`
	max-width: 1420px;
	padding: 20px;
	margin: 0 auto;
	@media (max-width: ${media.mobile}) {
		min-height: 100%;
		padding: 0;
	}
`;

export const PredictionsLite: React.FC = () => {
	const dispatch = useDispatch();
	const predictorRef = useRef<HTMLDivElement>(null);
	const isFullPredictions = useSelector(checkIsFullPredictions);
	const isChangePredictor = useSelector(checkIsChangePredictor);
	const [showMore, setShowMore] = useState(false);
	const {t} = useTranslation(LANGUAGE_PATH);

	const handleShowMore = () => {
		setShowMore(!showMore);
	};

	useEffect(() => {
		dispatch(checkSavedPredictions());
	}, [dispatch]);

	useEffect(() => {
		if (isFullPredictions && isChangePredictor) {
			dispatch(handleModalState({drawConfirmation: true}));
			dispatch(savePredictionsInStorage());
		}
	}, [dispatch, isFullPredictions, isChangePredictor]);

	return (
		<PredictionsWrap ref={predictorRef}>
			<Inner>
				<PreRegistration title="landing.page.header" subTitle="draw.title.body_copy" />
			</Inner>
			<PredictorContainer>
				<MoreButton onClick={handleShowMore}>
					{showMore ? "LESS" : t("mobile.group.more")}
				</MoreButton>
				<PredictionWrapper className="draw-fifth-step">
					{map(Groups, (group) => (
						<GroupPredictions group={group} key={group} showMore={showMore} />
					))}
				</PredictionWrapper>
				<LogoWrapper>
					<img src={officialPartner} alt="Official Airline Partner" />
					<img src={qatarWhite} alt="Qatar Airways" />
				</LogoWrapper>
			</PredictorContainer>
			<LiteSquadSelect />
			<EditPredictionLIteModal />
			<DrawConfirmationModal />
			<Tour tourRef={predictorRef} />
		</PredictionsWrap>
	);
};
